import { CSSProperties } from 'react'

const getCssValue = (value?: number | string) => {
  if (isNaN(Number(value))) {
    return value
  }
  return `${value}px`
}

const resolveGridTemplateColumns = (
  columns: number,
  minWidth?: string | number,
  maxWidth?: string | number
) => {
  const range = `minmax(${getCssValue(minWidth) ?? '0px'}, ${
    maxWidth ? getCssValue(maxWidth) : '1fr'
  })`
  return `repeat(${columns}, ${range})`
}

export const resolveGridStyles = (
  columns?: number,
  minWidth?: string | number,
  maxWidth?: string | number
): CSSProperties => {
  if (!columns) {
    return {
      display: 'flex',
      flexFlow: 'row wrap'
    }
  }
  const gridTemplateColumns = resolveGridTemplateColumns(
    columns,
    minWidth,
    maxWidth
  )

  return {
    display: 'grid',
    gridTemplateColumns
  }
}
